import React from "react";
import { BoardList, PostForm } from '../BoardListN/index';

function BoardPage() {
  return (
    <div>
      <BoardList />
      {/* <PostForm /> */}
    </div>
  );
}

export default BoardPage;
